import React, { useEffect, useState } from "react";
import "./CommunicationTab.scss";
import {
  getCardholderemessages,
  getCardholdermessages,
} from "../../../util/API/customers";
import SMStable from "../../SMSTable/SMStable";
import UserEmailTable from "../../UserEmailTable/UserEmailTable";
import { Box } from "@mui/material";

function CommunicationTab({
  selectedUser,
  selectedUserData,
  setSelectedUserData,
}) {
  const [emailData, setEmailData] = useState([]);
  const [smsData, setSMSData] = useState([]);
  const [showData, setShowData] = useState("SMS");

  let isAdmin = sessionStorage.getItem("isAdmin");

  // console.log(isAdmin)


  const handleTableChange = () => {
    if (showData == "SMS") {
      setShowData("email");
    } else {
      setShowData("SMS");
    }
  };

  useEffect(() => {
    const getMessages = async () => {
      let smsMessages = await getCardholdermessages(
        // selectedUserData?.User?.telephoneno,
        selectedUserData?.User?.id,
        isAdmin
      );
      // console.log("selectedUserData=======================",selectedUserData);
      let emailMessages = await getCardholderemessages(
        selectedUserData?.User?.id
        // selectedUserData?.Useremailaccount?.emailAccount
      );
      let emailRecord = [];
      if (Array.isArray(emailMessages?.data?.payload?.record)) {
        emailRecord = emailMessages?.data?.payload;
      } else {
        if (emailMessages?.data?.payload == "") {
          emailRecord = emailMessages?.data?.payload;
        } else {
          emailRecord["record"] = [emailMessages?.data?.payload?.record];
        }
      }
      if (smsMessages?.callStatus == 1) {
        setSMSData(smsMessages?.payload);
      }
      setEmailData(emailRecord);
    };

    getMessages();
  }, [selectedUser, isAdmin]);

  // console.log(smsData)

  //@Param date: format `YYYY-MM-DD HH:MM:SS`
  const formatDate = (date) => {
    const [day, time] = date.split(" ");
    return { day: day.slice(2, 10), time };
  };

  let switchButtonText = showData === "email" ? "View SMS" : "View Emails";

  return (
    <Box className="table-sizing" sx={{ overflow: "auto" }}>
      <Box
        className="d-flex justify-content-end switch-button-container pointer"
        onClick={handleTableChange}
      >
        <Box className="switch-button">{switchButtonText}</Box>
      </Box>
      {showData == "email" ? (
        <UserEmailTable emailData={emailData} />
      ) : (
        <SMStable smsData={smsData} />
      )}
    </Box>
  );
}

export default CommunicationTab;
